import { FaturaListSearchComponent } from './FaturaListSearchComponent'
import { UsersListGrouping } from './UsersListGrouping'

export const FaturaListHeader = () => (
  <div className='card-header border-0 pt-6'>
    <FaturaListSearchComponent actions={<UsersListGrouping />} />
  </div>
)
